<template>
  <div :class="classes">
    <pt-page-title title="存储报名" :isSearch="true" @search="search" :searchKey="searchKey"  @emptySearch="emptySearch"></pt-page-title>
     <!-- <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportCustomer" :loading="exportLoading">导出</el-button>
          <el-button type="primary" @click="exportHistoryCustomer">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter> -->
    <pt-save-sign-table  :paramsData="paramsData" :isFromRouter="isFromRouter" :class="$style['sign-table']">
       <template>
          <el-table-column label="操作" fixed="right">
            <template  slot-scope="scope">
               <el-button type="text" @click="copyLink(scope.row)" v-clipboard:copy="copyContentId(scope.row)" v-clipboard:success="onCopy" v-clipboard:error="onError">复制ID</el-button>
            <el-button type="text" @click="copyLink(scope.row)" v-clipboard:copy="copyContent(scope.row)" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</el-button>
          <!-- <el-button type="text" @click="getDetail(scope.row)">详情</el-button> -->
          <el-button type="text" @click="signList(scope.row)">报名记录</el-button>
            </template>
          </el-table-column>
        </template>
    </pt-save-sign-table>
  </div>
</template>

<script>
// 组件class前缀
import ptSaveSignTable from './pt-save-sign-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-save-sign'
export default {
  name: 'pt-save-sign',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptSaveSignTable
  },
  data () {
    return {
      searchKey: null,
      params: {},
      paramsData: {},
      isFromRouter: false
    }
  },
  methods: {
    copyContent (row) {
      return '/sign-form?id=' + row.id
    },
    copyContentId (row) {
      return row.id
    },
    copyLink (row) {},

    onCopy () {
      this.$message.success('复制成功，请前往您需要的位置粘贴')
    },
    onError () {
      this.$message.error('复制失败')
    },
    signList (row) {
      this.$router.push('/save-sign/save-sign-notes/' + row.name + '/' + row.id)
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      if (this.params.signTime) {
        this.params = { ...this.params, ...this.params.signTime }
        this.$delete(this.params, 'signTime')
        this.$delete(this.params, 'index')
      }
      this.paramsData = { ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    cleanParams () {
      emptyObject(this.paramsData)
      emptyObject(this.params)
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      this.paramsData.searchKey = val
    },
    emptySearch () {
      this.searchKey = null
      this.paramsData.searchKey = null
    },
    hasRemark (val) {
      return val.genericFormData && val.genericFormData.data && val.genericFormData.data.remark
    },
    viewRemark (val) {
      let remark = val.genericFormData && val.genericFormData.data && val.genericFormData.data.remark
      this.$alert(remark, '查看备注', {
        confirmButtonText: '确定',
        callback: action => {
        }
      })
    },
    getDetail (row) {
      this.$router.push('/save-sign/save-sign-detail/' + row.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
